import { useState } from 'react';

import { Honeybadger } from '@honeybadger-io/react';
import { isEqual } from 'lodash';
import { useRecoilState } from 'recoil';

import { requestApi } from 'api/Api';

import { getChangedFields, io } from 'lib/helpers/utility';

import { userState as user_state } from 'components/state';

const useDisplaySettings = () => {
  const [userState, setUserState] = useRecoilState(user_state);
  const [loading, setLoading] = useState(false);

  const displaySettings = userState?.display_settings;

  const saveDisplaySettings = async (updatedSettings) => {
    setLoading(true);
    try {
      const changedFields = getChangedFields(displaySettings, updatedSettings);
      console.log({ changedFields });
      if (io(changedFields)) {
        const params = {
          practitioner_id: userState.id,
          fields: {
            display_settings: { ...changedFields }
          }
        };

        setUserState({ ...userState, display_settings: updatedSettings });

        requestApi({
          url: '/api/practice/settings/practice_user/update',
          params
        }).then((data) => {
          if (data?.display_settings && !isEqual(updatedSettings, data?.display_settings)) {
            setUserState({ ...userState, display_settings: data?.display_settings });
          }
        });
      }
    } catch (error) {
      Honeybadger.notify(`Display settings - Error: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  return { userState, displaySettings, saveDisplaySettings, loading };
};

export default useDisplaySettings;
